import DOMPurify from "dompurify"

export const sanitizeConfig = {
  ALLOWED_TAGS: ["p", "strong", "em", "ins", "b", "i", "span", "br", "a", "ul", "ol", "li"],
  ALLOWED_ATTR: ["class", "style", "href", "target"],
  ALLOWED_URI_REGEXP: /^(?:https?:\/\/|mailto:|tel:)/i, // Only allow http://, https://, mailto:, and tel:
  ADD_ATTR_CHECK: true,
  FORBID_ATTR: ["onerror", "onload", "onclick"],
  ALLOW_DATA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false,
}

export const hasHtmlTags = str => {
  return typeof str === "string" && /<[a-z][\s\S]*>/i.test(str)
}

export const sanitizeHtml = (content, config = sanitizeConfig) => {
  if (!content) return ""
  return DOMPurify.sanitize(content, config)
}
